import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useAuthenticator } from "@aws-amplify/ui-react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { fetchUserAttributes } from "aws-amplify/auth";
import OrderComponent from "../components/Orders";
import ContentLayoutFooterNoChartreuse from "../components/Layout/ContentLayoutFooterNoChartreuse";

function Orders() {
  const router = useRouter();
  const [userEmail, setUserEmail] = useState("");
  const { authStatus, user } = useAuthenticator((context) => [
    context.authStatus,
    context.user,
  ]);

  async function handleFetchUserAttributesEmail() {
    try {
      const userAttributes = await fetchUserAttributes();
      setUserEmail(userAttributes.email);
      return userAttributes.email;
    } catch (error) {
      console.log(error);
      return "";
    }
  }

  useEffect(() => {
    if (authStatus === "unauthenticated") {
      router.push("/login");
    }
    if (authStatus === "authenticated" && user) {
      handleFetchUserAttributesEmail();
    }
  }, [authStatus, user, router, userEmail]);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <ContentLayoutFooterNoChartreuse title="Orders">
      <h1 className="flex items-center justify-center pt-5 px-2 sm:px-20">
        {" "}
        Order History{" "}
      </h1>
      <div className={isSmallScreen ? "px-2 py-1" : "px-20 py-10"}>
        <OrderComponent email={userEmail} />
      </div>
    </ContentLayoutFooterNoChartreuse>
  );
}

export default Orders;

export async function getStaticProps() {
  return {
    props: { page: "Orders" },
  };
}
